import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
// import RoleMasterPopup from "./RoleMasterPopup"
import RoleMasterPopup from "./RoleMasterPopup"
import DeletePopup from "../GardenPopup/DeletePopup"
// import { RoleMasterDDL } from "../../../../Components/CommonDDL/RoleMasterDDL"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
// import { RoleMasterDeleteAPI, RoleMasterTableDataAPI } from "../../../../Redux/SidebarMasterSlice/DesignationSlice"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { Loading } from "../../../../Helper/Loading"
import { RoleDeleteAPI, RoleTableDataAPI } from "../../../../Redux/SidebarMasterSlice/WaterSupplySidebarSlice/RoleMasterSlice"
import { RoleNameDataDDL } from "../../../../Components/CommonDDL/RoleNameDataDDL"
import { DepartmentDataDDL } from "../../../../Components/CommonDDL/DepartmentDataDDL"
import { ProjectTypeDataDDL } from "../../../../Components/CommonDDL/ProjectTypeDataDDL"

export const RoleMaster = () => {

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")

    // console.log(DashboardName)

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [Role, setRole] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Department, setDepartment] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // console.log(CurrentPage)
    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })

    const [RolePopupShow, setRolePopupShow] = useState()

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setRolePopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setRolePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setRolePopupShow(false)
    }

    const [PopUpField, setPopUpField] = React.useState({
        addPopUp: false,
        deletePopUp: false,
        popupFlag: '',
        popupBtn: "",
        apiFlag: "",
        rowData: ''
    })
    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setRole({
            ...Role,
            ID: 0,
            Label: 'Select...',
        })

        setDepartment({
            ...Department,
            ID: 0,
            Label: 'Select...',
        })


        // console.log("call")
    }


    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }

    }


    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    useEffect(() => {
        const data = {
            // FinancialYearID: YearValue,
            // M_DesignationID: Designation.ID,
            M_RoleID: Role?.ID,
            M_ProjectTypeID: ProjectType?.ID,
            Role: '',
            M_UsersID: UserID,
            token: token,
            From: From,
            To: To,
            Flag: ApiFlag,
        }
        // if (YearValue !== 0) {
        dispatch(RoleTableDataAPI({ data }))
        // }

    }, [IsPost, To, IsClear, isSearch, ProjectType?.ID])

    const { tableData, isLoading } = useSelector(state => state.RoleTableData)

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [RoleMaster.ID])

    const handleDeleteApi = (item) => {

        const data = {
            M_RoleID: item.m_RoleID,
            M_UserID: UserID,
            token: token,
            // Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(RoleDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.RoleDeleteData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }
    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active="rolemaster" listActive="masters" />
                    <div id="" className="content1">
                        <div className="data_mob1">
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="ps-1 py-1 m-0">Role Master</h5>

                                    <span style={{ fontSize: "16px", color: "gray", fontWeight: "bold" }}>
                                        Total Count: {tableData && tableData.table && tableData.table.length > 0 ? tableData.table[0].totalCount : 0}
                                    </span>

                                    <div>
                                        {/* <RoleMasterPopup
                                            open={RoleMasterPopupShow}
                                            handleIsPost={handleIsPost}
                                        /> */}
                                        <i className="fa-solid fa-plus btn btn-secondary"
                                            style={{ color: "white" }} onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12">

                                            <div className="row py-1 rounded2">
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <ProjectTypeDataDDL
                                                        ProjectType={ProjectType}
                                                        setProjectType={setProjectType}
                                                        IsPost={IsPost}
                                                        M_ProjectTypeID={M_ProjectTypeID}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <RoleNameDataDDL
                                                        Role={Role}
                                                        setRole={setRole}
                                                        M_ProjectTypeID={ProjectType?.ID}
                                                        M_ProjectTypeID={M_ProjectTypeID}
                                                    // rowData={item}
                                                    />
                                                </div>
                                                {/* <div className="col-12 col-md-4 col-lg-3">
                                                    <DepartmentDataDDL
                                                        Department={Department}
                                                        setDepartment={setDepartment}
                                                    />
                                                </div> */}
                                                <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Project Type</th>
                                                            <th>Role Name</th>
                                                            <th className="action-col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                                <tr style={{ width: '100%' }}>
                                                                    <td className="sr-no-col" style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    <td>{item.projectType ? item.projectType : '-'}</td>
                                                                    <td>{item.role ? item.role : '-'}</td>
                                                                    <td style={{ textAlign: "center", width: '7%' }}>
                                                                        {/* <span >
                                                                            <RoleMasterPopup
                                                                                open={RoleMasterPopupShow}
                                                                                item={item}
                                                                                EditIcon='Update'
                                                                                Flag='Update'
                                                                                handleIsPost={handleIsPost}
                                                                            />
                                                                        </span> */}
                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>

                                                                        <span>
                                                                            <DeletePopup
                                                                                open={DeletePopupShow}
                                                                                handleDeleteApi={handleDeleteApi}
                                                                                item={item}
                                                                            />
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ) :
                                                                <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    RolePopupShow ?
                        <RoleMasterPopup
                            open={RolePopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>

        </>
    )
}